export const IFRAME_MIN_WIDTH = 300;
export const IFRAME_MAX_WIDTH = 600;
export const TIMEOUT_VALUE = 500;
export const IFRAME_EXTRA_PADDING = 30;
export const IFRAME_RATIO = 1.22;
export const SHADE_SIDEBAR_HEIGHT_RATIO = 0.7;
export const COMPARE_BUTTON_HEIGHT = 225;
export const SKIN_SMOOTH_STRENGTH = 50;
export const PIE_CHART_DEFAULT_VALUE = 1;
export const CUSTOM_SLIDES_TO_SHOW = 5;
export const CUSTOM_SLIDES_TO_SCROLL = 5;
export const VTO_GUID = 'guid';
export const NO_SCROLL_CLASS = 'no-scroll';
export const VTO_ACTIVE_CLASS = 'vto-active';
export const VTO_DISCLOSE_PARAM = 'vto_disclose';
export const VTO_HIDE_PRICE_PARAM = 'vto_disprice';
export const VTO_OPEN_PARAM = 'vto_open';
export const VTO_MATCHES_COOKIE_NAME = 'vtoMatches';
export const VTO_PERSONALIZATION_VERIFIED_COOKIE = 'vto.p13n.verified';
export const SHADE_SIDEBAR_CONTAINER = 'js-product-shade-info-wrapper';
export const LEFT_STICKY_COLUMN = 'js-left-sticky-column';
export const LEFT_COLUMN_SECTION = 'js-left-column-section';
export const PRODUCT_FULL_SECTION = 'js-product-full';
export const PERLGEM_USER_IDENTIFIER_TYPE = 'perlgem_user_id';
export const VTO = 'vto';
export const VTO_FOUNDATION = 'vtoFoundation';
export const VTO_MATCHES = 'vtoMatches';
export const API_REQUEST_TIMEOUT = 100;
export const DOWNLOAD_BAR_SIZE = 50;
export const DOWNLOAD_BAR_TOLERANCE = 0.3;
export const DOWNLOAD_BAR_VARIATION = 1;

export enum VtoEvents {
    CAMERA_CLOSED = 'cameraClosed',
    CAMERA_FAILED = 'cameraFailed',
    CAMERA_OPENED = 'cameraOpened',
    CLOSED = 'closed',
    COMPARE = 'compare',
    COMPARE_DISABLED = 'compareDisabled',
    ENGINE_CLOSED = 'engineClosed',
    KISS_DETECTED = 'kissDetected',
    LOADED = 'loaded',
    LOADING = 'loading',
    OPENED = 'opened',
    PHOTO_LOADED = 'photoLoaded',
    PHOTO_SAVED = 'photoSaved',
    RESET = 'reset',
    SHADE_FINDER_COMPLETED = 'shadeFinderCompleted',
    SHADE_FINDER_CANCELLED = 'shadeFinderCancelled',
    SHADE_FINDER_STARTED = 'shadeFinderStarted',
    SKIN_SHADE_FOUND = 'skinShadeFound',
    SPLIT_FOUR_WAY = 'splitFourWay',
    SPLIT_FOUR_WAY_DISABLED = 'splitFourWayDisabled',
    VIDEO_LOADED = 'videoLoaded',
    ZOOM = 'zoom'
}

export enum FoundationShadeTypes {
    COOLER = 'cooler',
    LIGHTER = 'lighter',
    BEST = 'best',
    DARKER = 'darker',
    WARMER = 'warmer'
}

export enum FoundationPairShadeTypes {
    CASUAL = 'casualPair',
    BEST = 'bestPair',
    GLAM = 'glamPair'
}

export const foundationTabs = Object.freeze({
    allShadesTab: 'allShades',
    pairShadesTab: 'pairShades',
    perfectShadesTab: 'perfectShades'
});

export enum VtoButtonTypes {
    ALL_SHADES = 'allShades',
    BEST_SHADES = 'bestShades'
}

export enum VtoTypes {
    FOUNDATION = 'Foundation',
    MAKEUP = 'Makeup',
    SKINCARE = 'Skincare'
}

export const LOADING_PERCENTAGE_EVENT_TRIGGERED = 10;
